import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type * as statuses from 'services/store/states';
import { Checkbox } from '@mui/material';
import { RadioButtonUnchecked } from '@mui/icons-material';
import Button from 'components/library/Button/Button';
import styles from './EndModal.module.css';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  config: ConfigState;
  status: typeof statuses[keyof typeof statuses];
  idAyomi: number;
};

export default function EndModal({
  config, idAyomi,
}: Props) {
  const { t } = useTranslation();

  const [step, setStep] = useState(1);

  const handleNextStep = (value: number) => {
    if (value === 6) {
      window.location.assign(config.contractor.replace('/0', `/${idAyomi}`));
    } else setStep(value);
  };

  const getImage = () => {
    switch (step) {
      case 1:
        return 'Group 838.png';
      case 2:
        return 'Group 927.png';
      case 3:
        return 'Group 841.png';
      case 4:
        return 'Group 928.png';
      default:
        return 'Group 838.png';
    }
  };

  return (
    <div className={styles.bodyModal}>
      <h3 className={styles.header}>{t('endModal.title')}</h3>
      {
        (step !== 5)
          ? (
            <>
              <img className={styles.image} src={`${process.env.PUBLIC_URL}/images/${getImage()}`} alt="details" />
              <h3 className={styles.header}>{t(`endModal.stepTitle${step}`)}</h3>
              <p className={styles.description}>{t(`endModal.stepDescription${step}`)}</p>
            </>
          )
          : (
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/Kj4AYVwBqmc"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.video}
            />
          )
      }
      <div className={styles.footerContainer}>
        <div className={styles.buttonSlider}>
          <Checkbox
            className={`${styles.checkboxSlider} ${step === 1 ? styles.checked : ''}`}
            icon={<RadioButtonUnchecked />}
            checkedIcon={<span />}
            checked={step === 1}
            onChange={() => handleNextStep(1)}
          />
          <Checkbox
            className={`${styles.checkboxSlider} ${step === 2 ? styles.checked : ''}`}
            icon={<RadioButtonUnchecked />}
            checkedIcon={<span />}
            name="documents"
            checked={step === 2}
            onChange={() => handleNextStep(2)}
          />
          <Checkbox
            className={`${styles.checkboxSlider} ${step === 3 ? styles.checked : ''}`}
            icon={<RadioButtonUnchecked />}
            checkedIcon={<span />}
            name="bank-check"
            checked={step === 3}
            onChange={() => handleNextStep(3)}
          />
          <Checkbox
            className={`${styles.checkboxSlider} ${step === 4 ? styles.checked : ''}`}
            icon={<RadioButtonUnchecked />}
            checkedIcon={<span />}
            name="bank-check"
            checked={step === 4}
            onChange={() => handleNextStep(4)}
          />
          <Checkbox
            className={`${styles.checkboxSlider} ${step === 5 ? styles.checked : ''}`}
            icon={<RadioButtonUnchecked />}
            checkedIcon={<span />}
            checked={step === 5}
            onChange={() => handleNextStep(5)}
          />
        </div>
        <div className={styles.flexRowEnd}>
          <Button
            className={styles.nextStepButton}
            variant="ghost"
            size="large"
            type="secondary"
            label={t('endModal.skip')}
            onButtonClick={() => handleNextStep(6)}
          />
          <Button
            className={styles.nextStepButton}
            variant="fill"
            size="large"
            type="secondary"
            label={t(step === 5 ? 'endModal.goDashboard' : 'endModal.next')}
            onButtonClick={() => handleNextStep(step + 1)}
          />
        </div>
      </div>
    </div>
  );
}
